/* eslint-disable no-undef, no-unused-vars */
import * as bootstrap from 'bootstrap';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import { GestureHandling } from "leaflet-gesture-handling";
import 'leaflet-groupedlayercontrol';


/** Directory of Post Type entries filtered by taxonomies and search terms */

jQuery(function ($) {
  const $directory = ($.directory = function () {
    return $(window).directory();
  });

  $.fn.directory = function (attr) {
    return this.each(function () {
      const apiUrl = attr['api_url'];
      const postType = attr['post_type'];
      const posts_per_page = attr['posts_per_page'];
      const defaultTerms = attr ['default_terms'] ?? [];
      const $filterItem = attr['filter_item'];
      const area = attr['area'];

      // The container for attaching posts
      const $entriesContainer = $(this);
      // Single entry overlay container
      const $singleEntryContainer = $('#singleEntryContainer');
      // The filters block
      const $entriesFilters = $('#entriesFilters');
      // Form select dropdowns
      const $filterSelectControl = $entriesFilters.find('.form-select');
      // Number of entries display
      const $entriesCount = $('#entriesCount');
      const $spinners = $('.spinners');
      let $spinnersEntry = $();

      const $searchInput = $('#searchField');
      const $cursorWaitElements = $('body, #entriesFilters, #entriesFilters *, #entriesContainer, #entriesContainer *');

      const currentPage = window.location.href;

      // Filter tags
      const $tagStrip = $('.tag-strip');
      const $filterPrompt = $('#filterPrompt');
      const $tagPlaceholder = $('.filter-tag');
      if ($tagPlaceholder.length) {
        $tagPlaceholder.removeClass('d-none').remove();
      }

      //Modal
      const directoryModalElement = document.getElementById('directoryListingsModal');
      const $directoryModal = new bootstrap.Modal(directoryModalElement, {});

      //Map
      const $mapContainer = $('#mapContainer');
      const is_map_page = $('body').hasClass('page-template-template-directory-map')
      let map, $group;

      //Carousel
      let prevScreen;



      // Rest api object
      let xhr;
      let timeout;

      // Get directory request params
      const getDirectoryParams = (paged = 1) => {
        // console.log('default', defaultTerms);
        const terms = defaultTerms.map(item => {
           return {taxonomy: item.taxonomy, term_id: item.term_id}
          }
        );

      if ($filterItem.length) {
        // Get terms from sidenav filters
        $filterItem.filter('.active').each(function () {
            terms.push({
              taxonomy: $(this).data('taxonomy'),
              term_id: $(this).data('term_id'),
            });
        });
      }

        if ($filterSelectControl.length) {
          // Get terms from select filters
          $filterSelectControl.each(function () {
            const val = $(this).val();
            if (val > 0 && val != '0') {
              terms.push({
                taxonomy: $(this).data('taxonomy'),
                term_id: val,
              });
            }
          });
        }

        const data = {
          terms: terms,
          searchTerm: $searchInput.length ? $searchInput.val() : '',
          paged: Math.max(1, paged),
          posts_per_page: posts_per_page,
        };

        // console.log('data', data, apiUrl);
        // console.log(apiUrl + postType + '/' + '?_wpnonce=478da3c1cf&_envelope=1');

        return {
          data: data,
          url: apiUrl + postType + '/',
        };
      };

      const debouncefilterDirectory = (delay = 0) => {
        clearTimeout(timeout);

        timeout = setTimeout(function () {
          filterDirectory(1);
        }, delay);
      };

      const filterDirectory = (paged = 1, is_map = false) => {
        clearTimeout(timeout);
        const params = getDirectoryParams(paged);

        if(is_map || is_map_page) {
          params.data['is_map'] = true;
          params.data['posts_per_page = 500'];
        }
        // console.log('filterDirectory', params);

        // $entriesContainer.addClass('d-none');
        // $entriesContainer.hide();
        $spinners.removeClass('d-none');
        $entriesCount.addClass('invisible');
        $cursorWaitElements.addClass('cursor-progress');

        if (xhr) {
          xhr.abort();
        }

        xhr = $.ajax({
          // eslint-disable-next-line no-undef
          url: params.url,
          method: 'GET',
          data: params.data,
          success: function (response) {
            $entriesContainer.html(response.content).show(); //.fadeIn(500);
            $entriesCount.html(response.count).removeClass('invisible');
            $spinners.addClass('d-none');
            $cursorWaitElements.removeClass('cursor-progress');

            // Card image animation (selector needs to be updated each time)
            // $('.card-img-top').addClass('has-transition');

            bindPagination();
            bindEntries();
            if ( is_map || is_map_page ) {
              addMarkers();
            }

            if (window.history.replaceState) {
              //prevents browser from storing history with each change:
              window.history.replaceState(null, '', currentPage);
            }

            appendTags();

            // console.log(response);
            console.log('entries loaded');
          },
          error: function (xhr, status, error) {
            console.log('error', error);
            $entriesCount.html('Sorry, something went wrong.').removeClass('invisible');
            $spinners.addClass('d-none');
            $cursorWaitElements.removeClass('cursor-progress');
          },
        });
      };

    /* Display OSM Map of entries */
     const initLeafletMap = (mapElement) => {

      if (!$mapContainer.length) return;

      let lat = 53.3466349;
      let lng = -6.2520881;

      if (L) {
        // console.log('has map');
        L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
        map = L.map(mapElement, {
          // scrollWheelZoom: false,
          gestureHandling: true,
        }).setView([lat, lng], 12);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
        }).addTo(map);


        // L.tileLayer(
        //   'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
        //   attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
        // }).addTo(map);

        // Adding Feature group to map
        // $group = L.featureGroup();
        $group = L.markerClusterGroup();
        $group.addTo(map);

        //remove all layers from FeatureGroup
        $group.clearLayers();

        // if ($mapContainer.hasClass('show-districts')) {
        //   initDistricts();
        // }

        initDistricts();

        addMarkers();
      }
    }

    const initDistricts = () => {

      const $showDistricts = $mapContainer.hasClass('show-districts');

      fetch(apiObj.districts_url)
      .then((response) => {
          if (!response.ok) {
            throw new Error (`HTTP error! Status: ${response.status}`);
          }
          return response.json()
        })
      .then((data) => {
        // console.log(data);
        // Overlay layers are grouped
      const groupedOverlays = {
        'All Districts': {},
        'Boundaries': {},
      };

      let boundariesLayer;

      const onEachFeature = (feature, layer) => {
        // console.log(layer);
        //Bind popup with postal property and name
        if (feature.properties) {
          const title = feature.properties.description;
          if (title && feature.properties.Name !== 'boundaries') {
            const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
            layer.bindPopup('<h4><a href="' + apiObj.site_url + '/in-dublin/areas/' + slug + '/">' + title + '</a></h4>');
            groupedOverlays['All Districts'][title] = layer;
            if (area == slug) {
              layer.addTo(map);
            }

          } else {
            if ($showDistricts) {
              map.fitBounds(layer.getBounds());
            }
            boundariesLayer = layer;
            groupedOverlays.Boundaries[title] = layer;
          }
        }

    }

    const setStyle = (feature) => {
      if (feature.properties && feature.properties.Name == "boundaries") {
        return {interactive: false, color: '#505593', fillOpacity: 0};
      } else {
        return {interactive: $showDistricts, color: '#179cd7', fillOpacity: 0};
      }
    }

      const layerData = L.geoJSON(data, {
        onEachFeature: onEachFeature,
        style: setStyle,
      });

      //Add all districts + boundaries to map or only the boundaries
      if ($showDistricts) {
        layerData.addTo(map);
      } else {
        boundariesLayer.addTo(map);
      }

      const options = {
        // Show a checkbox next to non-exclusive group labels for toggling all
        groupCheckboxes: true,
      };

      // Use the custom grouped layer control, not "L.control.layers"
      const layerControl = L.control.groupedLayers(null, groupedOverlays, options);
      map.addControl(layerControl);

      // Automatically check/uncheck the group toggle-all checkbox
      const $layersGroup = $('[id*="leaflet-control-layers-group"]');
      $layersGroup.on('change', function (e) {
        $layersGroup.each(function () {
          const $grpSelector = $(this).find('input[class|="leaflet-control-layers-group-selector"]');
          const $elements = $(this).find('input[class|="leaflet-control-layers-selector"]');
          const checkboxCount = $elements.filter(':checked').length;

          if (checkboxCount == $elements.length) {
            $grpSelector.prop('checked', true);
          } else {
            $grpSelector.prop('checked', false);
          }

          boundariesLayer.bringToFront();
        });
      });

      $layersGroup.trigger('change');

      })
      .catch((error) => console.error("Unable to fetch data:", error));

    }

    const addMarkers = () => {
      // console.log('mapEntries', mapEntries);
      //remove all layers from FeatureGroup
      if ($group) {
        $group.clearLayers();
      }

      $('#mapAlertContainer').removeClass('d-none');

      if (typeof dataFromQuery == 'undefined' || !dataFromQuery) {
        return;
      }

      const mapEntries = JSON.parse(atob(dataFromQuery));
      // console.log('mapEntries', mapEntries, mapEntries.length)

      if (!mapEntries || !mapEntries.length) {
        return;
      }

      mapEntries.map( (item) => {
        const markerStr = item['marker'];
        if (markerStr) {
          const pattern = /data-map-markers="([^"]*)"/;
          const match = markerStr.match(pattern);
          if (!match || !match.length) {
            return;
          }

          const match1 = match[1];
          const decoded = match1.replace(/&quot;/ig,'"');

          const markerArray = $.parseJSON(decoded);
          if (!markerArray || !markerArray.length) {
            return;
          }

          const lat = markerArray[0]['lat'];
          const lng = markerArray[0]['lng'];
          const url = item['url'];

          const $popupText = '<a href="' + url + '" class="h5 load-api" style="text-decoration: underline">' + item['title'] + '</a>';

          if (L && lat && lng) {
            const $latLng = L.latLng([lat, lng], {alt: item['title']});
            const $marker = L.marker($latLng);
            $marker.bindPopup( $popupText).on("popupopen", () => {
              $('.leaflet-popup-content .load-api').on('click', e => {
                e.preventDefault();
                loadEntry(url);
              });
            });

            $group.addLayer($marker);
            }
          }

      });

      if ($group.getLayers().length) {
        map.fitBounds($group.getBounds());
        $('#mapAlertContainer').addClass('d-none');
      }

    }

      // Load single entry by post_id or url
      const loadEntry = (singlePost) => {
        clearTimeout(timeout);
        // singlePost = singlePost.replace(window.location.origin + '/', '');
        // singlePost = singlePost.replace(/\/$/, '');
        // console.log('single post', singlePost);

        if (!singlePost) {
          return;
        }

        const params = getDirectoryParams();
        params.data['single_post'] = singlePost;
        // console.log('loadEntry', params);

        // $singleEntryContainer.html('Loading...');

        $cursorWaitElements.addClass('cursor-progress');
        $spinnersEntry.removeClass('d-none');

        if (xhr) {
          xhr.abort();
        }

        xhr = $.ajax({
          // eslint-disable-next-line no-undef
          url: params.url,
          method: 'GET',
          data: params.data,
          success: function (response) {
            // console.log('success');
            $singleEntryContainer.html(response.content);

            $directoryModal.show();

            // directoryModalElement.addEventListener('shown.bs.modal', event => {
            //   // reset map
            //   console.log('modal shown');
            //   $singleEntryContainer.html(response.content);

            //   // const $map = $('#singleEntryContainer .leaflet-map');
            //   // if ($map.length) {
            //   //   $map.attr('id', 'entryMap');
            //   //   console.log(L.DomUtil.get('entryMap'))
            //   //   // L.DomUtil.get('entryMap');

            //   //   // .invalidateSize();
            //   // }
            // })

            // $directoryModal.handleUpdate();

            $spinnersEntry.addClass('d-none');
            $cursorWaitElements.removeClass('cursor-progress');

            if (window.history.replaceState) {
              //prevents browser from storing history with each change:
              window.history.replaceState(null, '', currentPage);
            }

            // console.log(eventorganiserMapsAdapter);

            // setTimeout(function () {
            //   // eventorganiserMapsAdapter.openstreetmap.map('eo_venue_map-1');
            //   initMap();
            // }, 400);

            // console.log(response);
            console.log('entry loaded');
          },
          error: function (xhr, status, error) {
            console.log('error', error);
            $spinners.addClass('d-none');
            $singleEntryContainer.html('Sorry, something went wrong.');
            $directoryModal.show();

            // alert('Sorry, something went wrong.');
          },
        });
      };

      //Add tags to top strip
      const appendTags = () => {
        $('.filter-tag').remove();
        const $activeFilters = $filterItem.filter('.active');

      if ($activeFilters.length) {
        $filterPrompt.hide();
        $($activeFilters).each(function() {
            const $tag = $tagPlaceholder.clone();
            const $self = $(this);

            $tag.find('.tag-text').text( $self.text() );
            $tag.data('id', $self.data('id'));

            //Remove filter on click
            $tag.on('click', function(){
              $self.removeClass('active');
              $tag.remove();
              debouncefilterDirectory(100);
            });

            $tag.appendTo($tagStrip);
        });
      } else {
        $filterPrompt.show();
      }
      }

      // Load entry when clicking the article
      const bindEntries = () => {
        $entriesContainer.find('article .load-api').on('click', function (e) {
          e.preventDefault();
          $spinnersEntry.addClass('d-none');
          $spinnersEntry = $(this).parents('.card').find('.spinners-entry');
          loadEntry($(this).attr('href'));
        });

        $('#featureCarouselHeader a').on('click', function (e) {
          loadModalLink(e);
        });

        // $('#featureCarouselHeader .entry-title a, #featureCarouselHeader .more-link').on('click', function (e) {
        //   e.preventDefault();
        //   $spinnersEntry.addClass('d-none');
        //   $spinnersEntry = $();
        //   loadEntry($(this).attr('href'));
        // });

        // if (area) {
        //   console.log('area', area, document.referrer);
        //   const areaStr = '?area=' + area;
        //   let href, newHref, index;

        //   $entriesContainer.find('article .append-area').each(function () {
        //     $(this).attr('href', $(this).attr('href') + areaStr);
        //   });

        //   $('#featureCarouselHeader .more-link, #featureCarouselHeader .entry-title a').each(function () {
        //     href = $(this).attr('href');
        //     index = href.indexOf('#');

        //     if (index > -1) {
        //       newHref = href.slice(0, index) + areaStr + href.slice(index);
        //     } else {
        //       newHref = href + areaStr;
        //     }

        //     $(this).attr('href', newHref);
        //   });
        // }

      };

      //Find next or prev page
      const findPage = (dir) => {
        const $current = $('#entriesContainer .page-numbers.current');
        if ($current.length) {
          return Number($current.text()) + dir;
        }
        return 1;
      };

      //Bind pagination after ajax is loaded
      const bindPagination = () => {
        $('#entriesContainer .page-numbers').on('click', function (e) {
          e.preventDefault();
          let paged;

          if ($(this).hasClass('next')) {
            //Find next page
            paged = findPage(1);
          } else if ($(this).hasClass('prev')) {
            //Find previous page
            paged = findPage(-1);
          } else {
            //Selected page
            paged = Number($(this).text());
          }

          document
            .getElementById('entriesContainer')
            .scrollIntoView();

          // console.log('paged', paged);

          filterDirectory(paged);
        });

        bindCarouselPagination();

      };

      //Bind pagination after ajax is loaded
      const bindCarouselPagination = () => {

        const $featureCarousel = $('#featureCarouselHeader');
        if ($featureCarousel.length) {

          const changePage = (e, paged) => {
            e.preventDefault();
            $featureCarousel.css('pointer-events', 'none');

            document
            .getElementById('entriesContainer')
            .scrollIntoView();

            // console.log('paged', paged);

            filterDirectory(paged);
          }

          if (prevScreen) {
            $featureCarousel.find('.first').removeClass('active');
            $featureCarousel.find('.last').addClass('active');
          }

          if ($featureCarousel.data('last-page')) {
            $featureCarousel.find('.carousel-item.last .carousel-control-next').addClass('d-none');
          }
          if ($featureCarousel.data('first-page')) {
            $featureCarousel.find('.carousel-item.first .carousel-control-prev').addClass('d-none');
          }

          $featureCarousel.on('slide.bs.carousel', function (e) {
            // console.log(e, e.direction)
            let paged;
            prevScreen = false;

            if (e.direction == 'left' && e.to == 0) {
              if ($featureCarousel.data('last-page')) {
                // do nothing
                e.preventDefault();
              } else {
                paged = findPage(1);
                changePage(e, paged);
              }

            } else if (e.direction == 'right' && e.from == 0) {
              if ($featureCarousel.data('first-page')) {
                // do nothing
                e.preventDefault();
              } else {
                prevScreen = true;
                paged = findPage(-1);
                changePage(e, paged);
              }
            }
          });

        }
      };

      // Select sidenav filter
      const selectFilter = ($ele) => {
        // console.log('selectFilter', $ele);

        if ($filterItem.length) {
          $filterItem.not($ele).removeClass('active');
          $filterItem.not($ele).attr('aria-selected', 'false');
          $ele.addClass('active');
          $ele.attr('aria-selected', 'true');
          debouncefilterDirectory(100);
        }
      };

      // Clear filters
      const clearFilters = ($ele) => {
        if ($filterItem.length) {
          $filterItem.removeClass('active');
          $filterItem.attr('aria-selected', 'false');
          debouncefilterDirectory(100);
        }
      };

      if ($filterSelectControl.length) {
        $filterSelectControl.on('change', function () {
          // console.log('change', $(this).val());
          debouncefilterDirectory(100);
        });
      }

      if ($filterItem.length) {
        $filterItem.on('click', function (e) {

          e.preventDefault();

          if (!$(this).hasClass('active')) {
            //Select this filter if it's not currently active
            selectFilter($(this));
          } else {
            //Otherwise deselect all filters
            clearFilters();
          }
        });
      }

      if ($searchInput.length) {
        $searchInput.on('search change keyup paste', function () {
          console.log('search');
          debouncefilterDirectory(1000);
        });

        $('#searchButton').on('click', function () {
          debouncefilterDirectory(200);
        });
      }

      $('#clearButton').on('click', function () {
        if ($searchInput.length) {
          $searchInput.val('');
        }
        if ($filterSelectControl.length) {
          $filterSelectControl.val(0);
        }
        // $('#offcanvasFilters .children').collapse('hide');
        clearFilters();
        debouncefilterDirectory(100);
      });

      // $(directoryModalElement).detach().appendTo('body');

      directoryModalElement.addEventListener('shown.bs.modal', event => {
        // reset map
        // console.log('modal shown');

        const $map = $('#singleEntryLeafletContainer .leaflet-map');

        if ($map.length) {
          $map.detach().appendTo('#singleEntryLeafletContainer');
          $directoryModal.handleUpdate();
        }

        if (a2a) {
          a2a.init_all();

          $('.addtoany_share_save').on('click', function() {
            $directoryModal.hide();
          });
        }

        $('#directoryListingsModal .entry-content a').on('click', function (e) {
          loadModalLink(e);
        });

      })

      directoryModalElement.addEventListener('hide.bs.modal', event => {
        const $video = $('#directoryListingsModal iframe');
        if ($video.length) {
          const src = $video.prop('src');
          $video.prop('src', src);
        }
      });

      // Check if the passed link should be loaded in modal
      const isModalLink = ($ele, url, segment) => {

        if ($ele.parents('.entry-bottom').length ) {
          return false;
        }

        // const url = $ele.attr('href');
        let index = url.indexOf(segment);

        if (index === -1) {
          return false;
        }

        // Match if the segment is found and not the last one in the url
        if (url.length > index + segment.length) {
          return true;
        }

        return false;
      }

      const loadModalLink = (e) => {
        const $ele = $(e.currentTarget);
        const url = $ele.attr('href');

        if (isModalLink($ele, url, '/stories/') || isModalLink($ele, url, '/members-spotlight/')) {
          // console.log('match link');
          e.preventDefault();
          $directoryModal.hide();
          $spinnersEntry.addClass('d-none');
          $spinnersEntry = $();
          timeout = setTimeout(function () {
            loadEntry(url);
          }, 500);
          // loadEntry(url);
        }
      }

      bindPagination();
      initLeafletMap('mapContainer');
      bindEntries();
    });
  };
});
